import type { ReactElement, ReactNode } from 'react';

/**
 * The one panel frame: a 22 px header strip and a scrolling body, square and
 * one pixel wide. Everything is a panel — there is no second kind of container.
 *
 * Panels are *not* dockable any more: the desk layout follows the arrangement a
 * trader expects (navigator, watch, chart, ticket, toolbox), and a panel that can
 * teleport is a panel a trader has to hunt for. Sizes are still adjustable with
 * the splitters, and the arrangement is remembered per browser.
 */
export function Panel(props: {
  /** Legacy dock id: accepted so panel call sites stay simple, no longer used. */
  readonly id?: string;
  /** Legacy dock flag: the desk layout is fixed, nothing is dockable. */
  readonly dockable?: boolean;
  readonly title: string;
  readonly badge?: ReactNode;
  readonly actions?: ReactNode;
  readonly children: ReactNode;
  readonly className?: string;
  readonly bodyClassName?: string;
  readonly footer?: ReactNode;
}): ReactElement {
  return (
    <section className={`panel ${props.className ?? ''}`} aria-label={props.title}>
      <header className="panel-head">
        <span>{props.title}</span>
        {props.badge === undefined ? null : (
          <span className="faint normal-case tracking-normal">{props.badge}</span>
        )}
        {props.actions === undefined ? null : <span className="ml-auto">{props.actions}</span>}
      </header>
      <div className={`panel-body ${props.bodyClassName ?? ''}`}>{props.children}</div>
      {props.footer}
    </section>
  );
}
